import { useTranslations } from 'next-intl';
import { IReviewsStats } from '@monofront/types';
import ReviewStars from '@monofront/design-system/components/ReviewStars';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';

interface IProductReviewsSumupProps {
  reviewsStats: IReviewsStats;
  starSize?: IconSizes;
  withAnchor?: boolean;
}

const ProductReviewsSumup: React.FC<IProductReviewsSumupProps> = ({
  reviewsStats,
  starSize = IconSizes.md,
  withAnchor = false,
}) => {
  const tCatalog = useTranslations('Catalog');

  if (
    !reviewsStats ||
    !reviewsStats.global?.count ||
    reviewsStats.global.count === 0
  )
    return null;

  const averageRating = reviewsStats.global.average_rating;
  const count = reviewsStats.global.count;

  return (
    <div className="tw-mt-2 tw-flex tw-items-center">
      <ReviewStars
        averageRating={averageRating}
        size={starSize}
        UNSAFE_className={`[&_svg]:tw-align-top`}
      />
      <p
        className={`
        tw-ml-2 tw-mt-0.5 tw-inline tw-font-semibold
        ${
          starSize === IconSizes.lg
            ? 'tw-text-lg [&_a]:tw-ml-2 [&_span]:tw-ml-2'
            : ''
        }
      `}
      >
        {`${averageRating.toFixed(1)}/5 `}
        {withAnchor ? (
          <a
            className="tw-lf-link-md tw-lf-link-dark tw-ml-1"
            href="#section-reviews"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('section-reviews');

              if (!element) return;

              element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
              element.focus({ preventScroll: true });
            }}
          >
            {`(${tCatalog('nbReviews', { nb: count })})`}
          </a>
        ) : (
          <span className="tw-font-normal">{`(${tCatalog('nbReviews', {
            nb: count,
          })})`}</span>
        )}
      </p>
    </div>
  );
};

export default ProductReviewsSumup;
